export default __webpack_public_path__ + "static/media/silver_plan.440b0cf5.svg";